import React from "react";
import { HALF_STAT, HALF_STAT_TEXT } from "../../../css/styles";
import { Segment } from "semantic-ui-react";

export default function StatisticWithText({
  heading,
  headingTextClass = "h2-text",
  stat,
  text,
  statFontSize = 30,
  textAlign = "center",
  vertical = true,
  isLoading = false,
}) {
  return (
    <div className="display-flex">
      <Segment
        basic
        style={HALF_STAT}
        textAlign={textAlign}
        vertical={vertical}
        loading={isLoading}
      >
        <div className={headingTextClass}>{heading}</div>
        <div style={{ fontSize: statFontSize, fontWeight: 600, padding: 10 }}>
          {stat}
        </div>
      </Segment>
      <div style={HALF_STAT_TEXT} className="not-print">
        <div className={"body-blue-text"}>{text}</div>
      </div>
    </div>
  );
}
